<style>
	.hamburger-menu {
		cursor: pointer;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		position: relative;
		width: 17px;
		height: 17px;
	}

	.bar {
		width: 100%;
		height: 2px;
		background-color: currentColor;
		will-change: transform;
		transition: all 300ms cubic-bezier(0.3, 1.5, 0.7, 1);
		border-radius: 1rem;
		position: absolute;
		left: 0;
		transform-origin: 0 0;
	}

	.hamburger-menu.align-right .bar.bottom:not(.open) {
		left: auto;
		right: 0;
	}

	.bar.top {
		top: 2px;
	}

	.bar.top.open {
		transform: translateX(2px) rotate(45deg);
		width: 20px;
		top: 1px;
	}

	.bar.bottom {
		width: 66%;
		bottom: 2px;
	}

	.bar.bottom.open {
		width: 20px;
		bottom: 0px;
	}

	.bar.middle {
		top: 50%;
		margin-top: -1px;
	}

	.middle.open {
		opacity: 0;
	}

	.bottom.open {
		transform: translateX(1px) rotate(-45deg);
	}
</style>

<script lang="ts">
	export let open = false;
	export let align = "left";
	let button: HTMLButtonElement;
	const handleOuterMousedown = (event: MouseEvent) => {
		if (open && !button.contains(event.target as Node)) {
			open = false;
		}
	};
</script>

<svelte:window on:click="{handleOuterMousedown}" />

<button
	type="button"
	class="flex font-medium flex-row items-center gap-2 p-3 {$$props.class ?? ''}"
	title="Menu"
	bind:this="{button}"
	on:click|preventDefault="{() => {
		open = !open;
	}}">
	<span class="hamburger-menu" class:align-right="{align === 'right'}">
		<span class="{open ? 'bar top open' : 'bar top'}"></span>
		<span class="{open ? 'bar middle open' : 'bar middle'}"></span>
		<span class="{open ? 'bar bottom open' : 'bar bottom'}"></span>
	</span>
	<slot />
</button>
